import { AuthType, GeneralSettings, PermissionsUtil, UserSettings } from "@mcleod/core";
import { Layout } from "./Layout";

export class LayoutValidator {
    private layout: Layout;

    constructor(layout: Layout) {
        this.layout = layout;
    }

    public validate() {
        if (!this.validateAuthType()) {
            throw Error("User is not authorized to view this layout")
        }

        if (PermissionsUtil.isUserDeniedLayout(this.layout.layoutName)) {
            throw Error("Permission denied for this layout");
        }

        if (this.layout.mcleodOnly && !UserSettings.get().is_support_user) {
            throw Error("User is not a support user");
        }

        if (this.layout.ideOnly && !GeneralSettings.getSingleton().isRunningInIDE()) {
            throw Error("User is not running from an IDE");
        }
    }

    private validateAuthType(): boolean {
        const authType = this.layout.auth ?? AuthType.LME;
        const userAuthType = UserSettings.getUserAuthType();

        return authType === AuthType.UNAUTH ||
               (authType === AuthType.ANY && userAuthType != null) ||
               authType === userAuthType ||
               userAuthType === AuthType.MCLEOD;
    }
}
